import { CommonModule } from "@angular/common";
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { AppService } from "../services/app.service";
import { SessionTimeoutService } from "../services/session-timeout.service";
import { FooterComponent } from "./footer";
import { HeaderComponent } from "./header";
import { SidebarComponent } from "./sidebar";
import { ThemeCustomizerComponent } from "./theme-customizer";

@Component({
  selector: "app-root",
  templateUrl: "./app-layout.html",
  standalone: true,
  imports: [
    CommonModule,
    ThemeCustomizerComponent,
    SidebarComponent,
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppLayout implements OnInit, OnDestroy {
  store: any;
  showTopButton = false;
  currentModule: string = "";

  constructor(
    public readonly translate: TranslateService,
    public readonly storeData: Store<any>,
    private readonly service: AppService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly sessionTimeout: SessionTimeoutService,
  ) {}

  headerClass = "";
  ngOnInit() {
    this.sessionTimeout.start();
    this.initStore();
    this.currentModule = this.activatedRoute.snapshot?.url[0]?.path || "";
    this.initAnimation();
    this.toggleLoader();
    window.addEventListener("scroll", () => {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        this.showTopButton = true;
      } else {
        this.showTopButton = false;
      }
    });
  }

  ngOnDestroy() {
    this.sessionTimeout.stop();
    window.removeEventListener("scroll", () => {});
  }

  initAnimation() {
    this.service.changeAnimation();
    this.router.events.subscribe((event: unknown) => {
      if (event instanceof NavigationEnd) {
        this.service.changeAnimation();
      }
    });

    const ele: any = document.querySelector(".animation");
    ele.addEventListener("animationend", () => {
      this.service.changeAnimation("remove");
    });
  }

  toggleLoader() {
    this.storeData.dispatch({ type: "toggleMainLoader", payload: true });
    setTimeout(() => {
      this.storeData.dispatch({ type: "toggleMainLoader", payload: false });
    }, 500);
  }

  initStore(): void {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  goToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
